<script setup lang="ts">

import { currency } from '@library/Utilities';
import Categories from "./Categories.vue";
import type { ICarbucksViewModel } from '@app/Carbucks';
import type { IMarketplaceViewModel } from '@app/MyMarketplace/Types/IMarketplaceViewModel';

import "./Header.scss";

type Props = { carbucks: ICarbucksViewModel };

const model = defineModel<IMarketplaceViewModel>( { required: true });
const { carbucks } = defineProps<Props>();

</script>

<template>

    <div class="z-20 bg-gradient-to-b from-gray-900 via-50% via-gray-900 to-transparent">

        <div class="py-2 3xl:py-4 rounded-t-sm rounded-b-xl flex flex-col gap-y-2 3xl:gap-y-4
                    bg-gradient-to-b from-gray-900 via-80% via-gray-800 to-gray-800
                    border-b border-gray-700
                    ring ring-gray-900/80"
             style="filter:drop-shadow( 0 5px 10px rgba( var(--RGB-gray-900), 0.8 ) )">

            <div class="px-2 lg:px-4 3xl:px-4 flex gap-x-2 3xl:gap-x-4 items-stretch">

                <div class="flex items-stretch gap-0.5 w-full rounded-lg overflow-hidden shadow-md">
                    <TextBox v-model="model.query"
                            placeholder="Search"
                            density="comfortable"
                            variant="solo"
                            rounded="none"
                            bg-color="rgba(255, 255, 255,0.1)"
                            flat
                            hide-details
                            clearable
                            @click:clear="() => model.search()"
                            @keypress.enter="() => model.search( model.query )">
                        <template #append-inner>
                            <IconButton name="search" @click="model.search( model.query )" class="-mr-2" />
                        </template>
                    </TextBox>

                    <Button to="/carbucks"
                            color="secondary"
                            height="auto"
                            variant="flat"
                            class="!flex !flex-col !border-2 !border-secondary-500 !rounded-none overflow-hidden">
                        <h1 v-if="true" class="carbucks-button !flex !flex-col items-center font-semibold">
                            <span class="mt-0.5">Cashback</span>
                            <div>{{ currency( carbucks.profile.availableAmount) }}</div>
                        </h1>
                    </Button>
                </div>

            </div>

            <Categories v-model="model" />

        </div>

    </div>
    
</template>
